module.exports = __webpack_public_path__ + "static/media/sidebar-5.81d1952c.jpg";